(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
			(global = global || self, (global.FullCalendarLocales = global.FullCalendarLocales || {}, global.FullCalendarLocales.da = factory()));
}(this, function () { 'use strict';
	var da = {
		code: "da",
		week: {
			dow: 1,
			doy: 4 // The week that contains Jan 4th is the first week of the year.
		},
		buttonText: {
			prev: busCalendarCustomDaLocale.prev,
			next: busCalendarCustomDaLocale.next,
			today: busCalendarCustomDaLocale.today,
			month: busCalendarCustomDaLocale.month,
			week: busCalendarCustomDaLocale.week,
			day: busCalendarCustomDaLocale.day,
			list: busCalendarCustomDaLocale.list
		},
		weekLabel: busCalendarCustomDaLocale.weekLabel,
		allDayText: busCalendarCustomDaLocale.allDayText,
		eventLimitText: busCalendarCustomDaLocale.eventLimitText,
		noEventsMessage: busCalendarCustomDaLocale.noEventsMessage
	};

	return da;

}));
